<template>
  <div class="forget_account">
    <el-form
      :model="loginForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="输入新的密码：" prop="password">
        <div class="content_a">
          <!-- <span>输入新的密码：</span> -->
          <el-input
            placeholder="请输入新的密码"
            class="input2"
            v-model.trim="loginForm.password"
            show-password
            @change="checkpassword"
          >
          </el-input>
        </div>
      </el-form-item>
      <div class="state_remind" v-if="loginForm.password == ''">
        <h5>密码长度为6-20位，需同时包含大小写字母和数字</h5>
      </div>
      <div
        class="pmgressbar"
        :class="{
          heightvalue: passwordlavel == 0,
          middlevalue: passwordlavel == 1,
          minvalue: passwordlavel == 2
        }"
        v-else
      >
        <span>密码强度：</span>
        <div></div>
        <div></div>
        <div></div>
        <span ref="textPawStyle">{{ textPaw }}</span>
      </div>
      <el-form-item label="再次输入新的密码：" prop="checkpass">
        <div class="content_a">
          <!-- <span>再次输入新的密码：</span> -->
          <el-input
            placeholder="请再次输入密码"
            class="input2"
            v-model.trim="loginForm.checkpass"
            show-password
          >
          </el-input>
        </div>
      </el-form-item>
    </el-form>

    <el-button type="primary" class="forget_btn" @click="nextfinish('ruleForm')"
      >下一步</el-button
    >
  </div>
</template>

<script>
import md5 from "js-md5";
import { strongPass, ModifyPass2 } from "@/utils/validata";
import forget from "@/api/forgetpassword";
export default {
  data() {
    return {
      passwordlavel: "", //密码校验登记
      send: true,
      sende: false,
      sended: false,
      passwordPercent: 0,
      textPaw: "",
      num: 2,
      timer: "",
      loginForm: {
        password: "", //新的密码
        checkpass: "" //确认密码
      },
      msgText: "",
      // 规则控制 - 规则字段一定要和数据的字段保持一致
      rules: {
        password: [{ validator: strongPass(this), trigger: "blur" }],
        checkpass: [{ validator: ModifyPass2(this), trigger: "blur" }]
      }
    };
  },
  props: ["cutcom"],
  methods: {
    submitForm(ruleForm) {
      // 确定校验
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    progressFn() {
      var ptr_digit = /^.*[0-9]+.*$/; // 是否包含数字
      if (this.loginForm.password === ptr_digit) {
        return "red";
      }
    },
    checkpassword() {
      let minreg = /^\d+$/; //纯数字
      let minreg2 = /^[A-Za-z]+$/; //纯字母
      let meddile = /^([0-9]+[a-zA-Z]+|[a-zA-Z]+[0-9]+)[0-9a-zA-Z]*$/; //字母加数字
      let meddile2 = /^(?![A-z0-9]+$)([A-z~@*()_]+$)(?![A-z0-9~@*()_]{8,})$/; //纯字母加特殊符号
      let meddile3 = /^(?![A-z0-9]+$)(?![A-z~@*()_]+$)([0-9~@*()_]+$)(?![A-z0-9~@*()_]{8,})$/; //纯数字和特殊符号
      let heightvalues = /^(?![A-z0-9]+$)(?![A-z~@*()_]+$)(?![0-9~@*()_]+$)([A-z0-9~@*.()_]{8,})$/; // 纯字母和数字和特殊符号
      if (minreg.test(this.loginForm.password)) {
        this.passwordlavel = 0; //纯数字
        console.log("纯数字");
        this.textPaw = "弱";
      }
      if (minreg2.test(this.loginForm.password)) {
        this.passwordlavel = 0; //纯字母
        console.log("纯字母");
        this.textPaw = "弱";
      }

      if (meddile.test(this.loginForm.password)) {
        this.passwordlavel = 1; //纯字母
        this.textPaw = "中";
        console.log("字母和数字");
      }
      if (meddile2.test(this.loginForm.password)) {
        this.passwordlavel = 1; //纯字母
        console.log("纯字母和特殊符号");
        this.textPaw = "中";
      }
      if (meddile3.test(this.loginForm.password)) {
        this.passwordlavel = 1; //纯字母
        console.log("纯数字和特殊符号");
        this.textPaw = "中";
      }
      if (heightvalues.test(this.loginForm.password)) {
        this.passwordlavel = 2; //纯字母
        console.log("字母和数字和特殊符号");
        this.textPaw = "高";
      }
    },
    nextfinish(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.loginForm.password === this.loginForm.checkpass) {
            //开始进入设置新密码
            let parmars = {
              guid: this.$parent.guid,
              phone: this.$parent.phone,
              newPwd: md5(this.loginForm.password)
            };
            let res = await forget.updatePwd(parmars);
            console.log(res);
            if (res.data.Status == 200) {
              this.$message({
                showClose: true,
                message: "密码重置成功",
                type: "success"
              });
              this.cutcom(3);
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      // console.log(1);
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.forget_account {
  width: 540px;
  height: 300px;
  // background-color: aquamarine;
  .content_a {
    display: flex;
    align-items: center;
    span {
      width: 150px;
      text-align: right;
      font-weight: 600;
      color: rgb(133, 131, 127);
    }
    .phone {
      width: 400px;
    }
    .account {
      font-size: 18px;
      font-weight: 600;
      color: orangered;
    }
  }
}
.state_remind {
  height: 50px;
  // background-color: bisque;
  h5 {
    float: right;
    margin: 15px 6px 0 0;
    font-family: PingFang SC;
    font-weight: 400;
    color: #bbbbbb;
  }
}
.pmgressbar {
  height: 50px;
  // background-color: bisque;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  span:nth-child(1) {
    display: inline-block;
    width: 75px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-right: 4px;
  }
  span:nth-last-of-type(1) {
    margin-left: 8px;
  }
  div {
    width: 50px;
    height: 5px;
    background: #f1f1f1f1;
    opacity: 1;
    border-right: 1px solid #fff;
    &:nth-last-of-type(1) {
      width: 70px;
      //   background: red;
    }
  }
}
.heightvalue {
  > :nth-child(2) {
    background-color: red;
  }
}
.middlevalue {
  > :nth-child(2) {
    background-color: red;
  }
  > :nth-child(3) {
    background-color: yellow;
  }
}
.minvalue {
  > :nth-child(2) {
    background-color: red;
  }
  > :nth-child(3) {
    background-color: yellow;
  }
  > :nth-child(4) {
    background-color: rgb(0, 255, 85) !important;
  }
}
.input2 {
  width: 390px;
}

.forget_btn {
  width: 300px;
  margin: 70px 150px;
}
::v-deep .el-form-item__label {
  width: 174px !important;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  opacity: 1;
}
::v-deep .el-form-item__content {
  margin-left: 174px !important;
}
::v-deep .el-form-item {
  margin-bottom: 10px !important;
}
.el-form {
  margin-top: 34px;
  display: flex;
  flex-direction: column;
}

.red {
  background: #ff0000 !important;
}
.yellow {
  background: #ffdd8d !important;
}
.green {
  background: #01d801 !important;
}
#inputValue {
  width: 240px;
  margin-left: 20px;
  padding-left: 10px;
  border-radius: 3px;
}
.input_span span {
  display: inline-block;
  width: 85px;
  height: 10px;
  background: #eee;
  line-height: 20px;
}

.one {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: 0px solid;
  margin-left: 20px;
  margin-right: 3px;
}

.two {
  border-left: 0px solid;
  border-right: 0px solid;
  margin-left: -5px;
  margin-right: 3px;
}

.three {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: 0px solid;
  margin-left: -5px;
}
</style>
